/**
 * @file CategoryHeaderSchemes.tsx
 * @description Мини-схемы вида шапки страницы категории для карточек-вариантов
 * `OptionCards` (phase19.16 Р2а; замечание пользователя 2026-10-12 «Нужна
 * визуализация»): только заголовок, заголовок с описанием, баннер с фото.
 * Под шапкой у всех трёх — ряд карточек товаров, чтобы было видно, где верх
 * страницы. Примитивы и рамка — общие (`schemes/CoverSchemes`).
 */

import type { SiteCatalogOptions } from "@chaiberi/shared";
import type { ReactNode } from "react";

import { Line, Photo, Scheme } from "../schemes/CoverSchemes";

/** Ряд карточек товаров внизу схемы — бледнее шапки. */
const Products = () => (
  <g>
    {[3, 23.5, 44].map((x) => (
      <rect key={x} x={x} y={28} width={17} height={10} rx={2} fill="currentColor" fillOpacity={0.15} />
    ))}
  </g>
);

const HEADER: Readonly<Record<SiteCatalogOptions["categoryHeader"], ReactNode>> = {
  // Одна строка заголовка.
  title: (
    <g>
      <Line x={3} y={8} w={30} h={4} />
      <Products />
    </g>
  ),
  // Заголовок и две строки описания.
  "title-description": (
    <g>
      <Line x={3} y={4} w={30} h={4} />
      <Line x={3} y={12} w={52} />
      <Line x={3} y={16} w={40} />
      <Products />
    </g>
  ),
  // Фото во всю ширину, заголовок и описание поверх.
  banner: (
    <g>
      <Photo x={0} y={2} w={64} h={22} />
      <Line x={6} y={9} w={30} h={4} light />
      <Line x={6} y={16} w={22} light />
      <Products />
    </g>
  ),
};

export const CategoryHeaderScheme = ({ header }: { header: SiteCatalogOptions["categoryHeader"] }) => <Scheme>{HEADER[header]}</Scheme>;
